module.exports = __webpack_public_path__ + "img/is.9c536cce.png";